var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./FetchService";
import { getXSRF } from "../src/Services/Shared/FetchService";
const DASHBOARD_URL = "/aviso/dashboard";
export default class DashboardService {
    static fetchDashboardAndWidgets(dashboardId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(`/aviso/dashboard/detail/${dashboardId}`);
        });
    }
    static fetchWidgets(dashboardId) {
        return FetchService.getSingleResponse("/aviso/dashboard/widgets", {
            dashboardId,
        }).then((response) => response);
    }
    static save(dashboard, dashboardWidgets) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/dashboard/update/${dashboard.id}`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify({
                    dashboard,
                    dashboardWidgets,
                }),
            });
            // @ts-expect-error - TS2314 - Generic type 'SingleResponse<T>' requires 1 type argument(s).
            const responseJson = yield response.json();
            return responseJson;
        });
    }
    static fetchFiltersForDashboard(search, options = {}) {
        return FetchService.getPagedResponse(DASHBOARD_URL + "/getFiltersForDashboard", {
            id: search.id,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        }).then((response) => {
            return response;
        });
    }
}
